<template>
  <el-tiptap
    lang="en"
    :extensions="extensions"
    v-model="content"
    placeholder="Write something ..."
    @onUpdate="textUpdated"
  />
</template>

<script>
import { ElementTiptap } from 'element-tiptap';
import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  Blockquote,
  ListItem,
  BulletList, // use with ListItem
  OrderedList, // use with ListItem
  TodoItem,
  TodoList, // use with TodoItem
  TextAlign,
  Indent,
  HorizontalRule,
  HardBreak,
  History,
  Fullscreen,
  CodeView
} from "element-tiptap";

import codemirror from "codemirror";
import "codemirror/lib/codemirror.css"; // import base style
import "codemirror/mode/xml/xml.js"; // language
import "codemirror/addon/selection/active-line.js"; // require active-line.js
import "codemirror/addon/edit/closetag.js"; // autoCloseTags
import 'element-tiptap/lib/index.css';

export default {
  components: {
    'el-tiptap': ElementTiptap,
  },
  props: {
    message: {
      type: String,
      default: "",
      required: false
    }
  },
  data: () => ({
    extensions: [
      new Doc(),
      new Text(),
      new Paragraph(),
      new Heading({ level: 5 }),
      new Bold({ bubble: true }),
      new Underline({ bubble: true }),
      new Italic({ bubble: true }),
      new Strike({ bubble: true }),
      new Link({ bubble: true }),
      new Image(),
      new Blockquote(),
      new TextAlign(),
      new ListItem(),
      new BulletList({ bubble: true }),
      new OrderedList({ bubble: true }),
      new TodoItem(),
      new TodoList(),
      new Indent(),
      new HardBreak(),
      new HorizontalRule({ bubble: true }),
      new Fullscreen(),
      new CodeView({
        codemirror,
        codemirrorOptions: {
          styleActiveLine: true,
          autoCloseTags: true
        }
      }),
      new History()
    ],

    content: ``
  }),
  methods: {
      textUpdated(){
          this.$emit('input', this.content);
      },
      append(appendingContent){
        var previousMessageLineIndex = this.content.indexOf('<p>------')
        var closingCarrotIndex = 0
        if(previousMessageLineIndex >= 0) {
          closingCarrotIndex = this.content.lastIndexOf('</', previousMessageLineIndex)
        }
        else {
          var closingCarrotIndex = this.content.lastIndexOf('</')
        }
        if(closingCarrotIndex >= 0) {
          this.content = this.content.slice(0,closingCarrotIndex) + appendingContent + this.content.slice(closingCarrotIndex)
        }
        else {
          this.content += appendingContent
        }
        this.$emit('input', this.content);
      },
      clearContent() {
        this.content = ''
        this.$emit('input', this.content);
      }
  },
  mounted() {
      if(this.message != '') {
        this.content = this.message;
        this.$emit('input', this.content);
      }
    }
};
</script>
